<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Relatórios</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="secundario"
          class="button"
          text="Exportar Excel"
          icon="assets/exportar-excel.svg"
          (click)="baixarQuantidadeVeiculosPatio()"
        ></app-botao>
        <app-botao
          type="secundario"
          class="button"
          text="Exportar PDF"
          icon="assets/download.svg"
          (click)="baixarQuantidadeVeiculosPatioPdf()"
        ></app-botao>
      </div>
    </div>

    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">{{ reportTitle }}</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters">
            <app-input
              label="Cód. Gate Entrada"
              placeholder="Digite aqui"
              name="PK_GATE_ENTR"
              formControlName="PK_GATE_ENTR"
              width="100%"
            ></app-input>
            <app-input
              label="Nome Empresa"
              placeholder="Digite aqui"
              name="NM_EPSA"
              formControlName="NM_EPSA"
              width="100%"
            ></app-input>
            <app-input
              label="Motorista"
              placeholder="Digite aqui"
              name="NM_MTRT"
              formControlName="NM_MTRT"
              width="100%"
            ></app-input>
            <app-input
              label="Placa Cavalo"
              mask="AAA-0A00"
              placeholder="Digite aqui"
              name="TX_PLCA_CAVA"
              formControlName="TX_PLCA_CAVA"
              width="100%"
            ></app-input>
            <app-input
              type="dropdown"
              label="Data de Referência"
              placeholder="Selecione"
              name="TIPO_DATA_REFERENCIA"
              formControlName="TIPO_DATA_REFERENCIA"
              [selectData]="tipoDataOptions"
              [coerceValue]="'number'"
              width="100%"
            ></app-input>
            <app-input
              type="dropdown"
              label="Agendado"
              placeholder="Selecione"
              name="FL_AGENDADO"
              formControlName="FL_AGENDADO"
              [selectData]="simNaoTodosOptions"
              [coerceValue]="'number'"
              width="100%"
            ></app-input>
            <app-input
              type="dropdown"
              label="Situação"
              placeholder="Selecione"
              name="NU_SITUACAO"
              formControlName="NU_SITUACAO"
              [selectData]="situacaoOptions"
              [coerceValue]="'number'"
              width="100%"
            ></app-input>
            <app-input
              type="dropdown"
              label="Período"
              placeholder="Selecione"
              name="NU_PERIODO"
              formControlName="NU_PERIODO"
              [selectData]="periodoOptions"
              [coerceValue]="'number'"
              width="100%"
            ></app-input>
            <app-input
              type="datetime-local"
              label="Data Início"
              placeholder="Digite aqui"
              name="DT_GATE_ENTR_INIC"
              formControlName="DT_GATE_ENTR_INIC"
              width="100%"
            ></app-input>
            <app-input
              type="datetime-local"
              label="Data Final"
              placeholder="Digite aqui"
              name="DT_GATE_ENTR_FIM"
              formControlName="DT_GATE_ENTR_FIM"
              width="100%"
            ></app-input>
          </form>
        </div>
      </div>

      <app-loader [isLoading]="isLoading"></app-loader>

      <div class="table-scroll" *ngIf="!isLoading">
        <app-tabela
          [data]="tableData"
          [columns]="tableColumns"
        ></app-tabela>
      </div>
    </div>
  </div>

  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Cód. Gate Entrada"
        placeholder="Digite aqui"
        name="PK_GATE_ENTR"
        formControlName="PK_GATE_ENTR"
        width="100%"
      ></app-input>
      <app-input
        label="Nome Empresa"
        placeholder="Digite aqui"
        name="NM_EPSA"
        formControlName="NM_EPSA"
        width="100%"
      ></app-input>
      <app-input
        label="Motorista"
        placeholder="Digite aqui"
        name="NM_MTRT"
        formControlName="NM_MTRT"
        width="100%"
      ></app-input>
      <app-input
        label="Placa Cavalo"
        mask="AAA-0A00"
        placeholder="Digite aqui"
        name="TX_PLCA_CAVA"
        formControlName="TX_PLCA_CAVA"
        width="100%"
      ></app-input>
      <app-input
        type="dropdown"
        label="Data de Referência"
        placeholder="Selecione"
        name="TIPO_DATA_REFERENCIA"
        formControlName="TIPO_DATA_REFERENCIA"
        [selectData]="tipoDataOptions"
        [coerceValue]="'number'"
        width="100%"
      ></app-input>
      <app-input
        type="dropdown"
        label="Agendado"
        placeholder="Selecione"
        name="FL_AGENDADO"
        formControlName="FL_AGENDADO"
        [selectData]="simNaoTodosOptions"
        [coerceValue]="'number'"
        width="100%"
      ></app-input>
      <app-input
        type="dropdown"
        label="Situação"
        placeholder="Selecione"
        name="NU_SITUACAO"
        formControlName="NU_SITUACAO"
        [selectData]="situacaoOptions"
        [coerceValue]="'number'"
        width="100%"
      ></app-input>
      <app-input
        type="dropdown"
        label="Período"
        placeholder="Selecione"
        name="NU_PERIODO"
        formControlName="NU_PERIODO"
        [selectData]="periodoOptions"
        [coerceValue]="'number'"
        width="100%"
      ></app-input>
      <app-input
        type="datetime-local"
        label="Data Início"
        placeholder="Digite aqui"
        name="DT_GATE_ENTR_INIC"
        formControlName="DT_GATE_ENTR_INIC"
        width="100%"
      ></app-input>
      <app-input
        type="datetime-local"
        label="Data Final"
        placeholder="Digite aqui"
        name="DT_GATE_ENTR_FIM"
        formControlName="DT_GATE_ENTR_FIM"
        width="100%"
      ></app-input>
    </form>

    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true"
    ></app-card>
  </div>

  <app-subtitulo *ngIf="!tableData.length">Nenhum registro encontrado.</app-subtitulo>

  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"
    ></app-paginacao>
  </div>

  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
